<section>
  <ul class="list-wrapper">

    <li *ngFor="let integration of integrationStatuses$ | async">
      <cc-integration-list-item
        [path]="'integrations/' + platform(integration)"
        [logoPath]="'assets/img/channels/logo-' + platform(integration) + '.svg'"
        [description]="'INTEGRATIONS.' + integration.platformType + '.LIST_TEXT'"
        [connectedIcon]="connectIcon(integration)"
        [isComingSoon]="!integration.availableToInstall"
        [isFree]="isFreePlan"
        [integrationType]="integration.platformType"
      ></cc-integration-list-item>
    </li>
    <li>
      <cc-integration-list-item
        path="/webhooks/list"
        logoPath="assets/img/channels/logo-webhooks.svg"
        description="INTEGRATIONS.WEBHOOK.LIST_TEXT"
        connectedIcon="assets/img/channels/arrow-connect.svg"
      ></cc-integration-list-item>
    </li>

    <li>
      <cc-integration-list-item
        path="/developers/api"
        logoPath="assets/img/channels/logo-apikey.svg"
        description="INTEGRATIONS.API_KEY.LIST_TEXT"
        connectedIcon="assets/img/channels/arrow-connect.svg"
      ></cc-integration-list-item>
    </li>

  </ul>
</section>
